import { composeStateMachine } from '@opengov/app-core/module';
import { castDraft, produce } from 'immer';

import { createReportHistory, IReportHistory, IReportHistoryState } from './records';

export const ReportHistoryInitialState: IReportHistoryState = {
  history: []
};

export const reportHistoryState = composeStateMachine('report-history', ReportHistoryInitialState, (compose) => ({
  clearReportHistory: compose.payloadlessAction((state) =>
    produce(state, (newState) => {
      newState.history = castDraft(ReportHistoryInitialState.history);
    })
  ),
  popReportHistory: compose.payloadlessAction((state) =>
    produce(state, (newState) => {
      newState.history.pop();
    })
  ),
  pushReportHistory: compose.action((state, payload: IReportHistory) =>
    produce(state, (newState) => {
      newState.history.push(castDraft(createReportHistory(payload)));
    })
  ),
  setReportHistory: compose.action((state, payload) =>
    produce(state, (newState) => {
      newState.history = payload;
    })
  ),
  keepOnlyTheLastHistory: compose.payloadlessAction((state) =>
    produce(state, (newState) => {
      newState.history = newState.history.slice(-1);
    })
  )
}));

export const {
  reducer: reportHistoryReducer,
  selector: reportHistorySelector,
  actionCreators: reportHistoryActionCreators,
  actions: reportHistoryActions
} = reportHistoryState;
